export const environment = {
  apiUrl: 'https://api.mkassa2.uz/',
  wsUrl: 'wss://api.mkassa2.uz/ws-qr',
};
